module.exports = __webpack_public_path__ + "static/media/logo.da211623.svg";